import { render, staticRenderFns } from "./Lgx315088047471329280.vue?vue&type=template&id=6a3bfa12&scoped=true&"
import script from "./Lgx315088047471329280.vue?vue&type=script&lang=js&"
export * from "./Lgx315088047471329280.vue?vue&type=script&lang=js&"
import style0 from "./Lgx315088047471329280.vue?vue&type=style&index=0&id=6a3bfa12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3bfa12",
  null
  
)

export default component.exports